import PausedIcon from "@assets/icons/pause.svg?react";
import PlayIcon from "@assets/icons/play.svg?react";
import clsx from "clsx";

import VideoPlayingIcon from "../VideoPlayingIcon/VideoPlayingIcon";

const ArticleTypeIcon = ({
  itemTypeProps,
  isVideoPlaying,
  isVideoPaused,
  rootClassName,
}: {
  itemTypeProps?: string;
  isVideoPlaying?: boolean;
  isVideoPaused?: boolean;
  rootClassName?: string;
}) => {
  return itemTypeProps === "video" ? (
    <div
      className={clsx(
        "pointer-events-none absolute left-1/2 top-1/2 flex size-[40px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-black/40",
        rootClassName,
      )}
    >
      {(() => {
        switch (true) {
          case isVideoPlaying:
            return <VideoPlayingIcon />;
          case isVideoPaused:
            return <PausedIcon fill="white" />;
          default:
            return <PlayIcon fill="white" />;
        }
      })()}
    </div>
  ) : null;
};

export default ArticleTypeIcon;
